import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Grid from "@mui/material/Grid";
import Loading from "components/Loading";
import Card from "@mui/material/Card";
import MDTypography from "components/MDTypography";
import React, { useState, useEffect } from "react";
import { useSnackbar } from 'notistack';
import { useAuth } from "hooks/useAuth";
import { useParams } from "react-router-dom";
import apiClient from "Api";
import MDInput from "components/MDInput";
import TimelineList from "examples/Timeline/TimelineList";
import TimelineItem from "examples/Timeline/TimelineItem";
import Chip from "@mui/material/Chip";
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

function Sale() {
    const [isLoading, setIsLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    const { paymentId } = useParams();
    const [payment, setPayment] = useState({});

    const [history, setHistory] = useState([]);

    function getSale() {
        setIsLoading(true);
        return apiClient.get(`/sales/${paymentId}`)
            .then(response => {
                setPayment(response.data);
                setIsLoading(false);
            }).catch((error) => {
                console.log(error);
                enqueueSnackbar("Erro ao retornar venda!", { variant: "error" });
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    useEffect(() => {
        getSale();
    }, []);

    useEffect(() => {

        let historyArray = [];
        {
            payment.history?.map((item, index, array) => {

                let desc = "";
                switch (item.type) {
                    case "SESSION_CREATED":
                        desc = "Sessão de pagamento criada";
                        break;
                    case "SESSION_UPDATED":
                        desc = "Sessão de pagamento atualizada";
                        break;
                    case "PROCESS_PAYMENT":
                        desc = "Processamento do pagamento";
                        break;
                    case "SHOPIFY_FINALIZE":
                        desc = "Notificação do status do pagamento enviada para Shopify";
                        break;
                    case "CIELO_WEBHOOK_PROCESS":
                        desc = "Webhook Cielo";
                        break;
                    case "REFUND_PAYEMNT":
                        desc = "Estorno";
                        break;
                }

                var metadata = null;

                if (item.metadata != "null") {
                    var metadataJson = JSON.parse(item.metadata);
                    metadata = <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Metadata
                        </AccordionSummary>
                        <AccordionDetails>
                            <pre style={{ overflow: "scroll" }}>{JSON.stringify(metadataJson, null, 2)}</pre>
                        </AccordionDetails>
                    </Accordion>
                }

                var error = null;

                if (item.error !== null) {
                    error = <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Error
                        </AccordionSummary>
                        <AccordionDetails>
                            <pre style={{ overflow: "scroll" }}>{item.error}</pre>
                        </AccordionDetails>
                    </Accordion>
                }

                historyArray.push(
                    <TimelineItem
                        key={item.type}
                        color={item.isSuccess ? "success" : "error"}
                        icon={item.isSuccess ? "done" : "priority_high"}
                        title={item.type}
                        dateTime={new Date(item.createdAt).toLocaleString()}
                        description={<><p>{desc}</p>{metadata}{error}</>}
                        lastItem={index === array.length - 1}
                    />
                )
            })
        }

        setHistory(historyArray);
    }, [payment])

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Loading isLoading={isLoading}></Loading>
            <MDBox pt={3} pb={3}>
                <Card>
                    <MDBox
                        mx={2}
                        mt={-3}
                        py={1.5}
                        px={2}
                        variant="gradient"
                        bgColor="info"
                        borderRadius="lg"
                        coloredShadow="info"
                    >
                        <MDTypography variant="h6" color="white">
                            Venda
                        </MDTypography>
                    </MDBox>
                    <MDBox p={4} pb={6} >
                        {payment.id !== undefined &&
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <MDTypography variant="h6">Pagamento</MDTypography>
                                        </Grid>
                                        <Grid item xs={12} md={6} sx={{ textAlign: "right" }}>
                                            <MDTypography variant="caption" color="text" fontWeight="medium">
                                                {payment.cieloData.status == undefined && payment.status != "SESSION_CREATED" && <Chip label="Erro" color="error" variant="outlined" />}
                                                {payment.cieloData.status == undefined && payment.status == "SESSION_CREATED" && <Chip label="Sessão de pagamento criada" color="info" variant="outlined" />}
                                                {payment.cieloData.status == "Pending" && <Chip label="Pendente" color="warning" variant="outlined" />}
                                                {payment.cieloData.status == "Authorized" && <Chip label="Autorizado" color="info" variant="outlined" />}
                                                {payment.cieloData.status == "Denied" && <Chip label="Negado" color="error" variant="outlined" />}
                                                {payment.cieloData.status == "NotFinished" && payment.appType != "CreditCard" && <Chip label="Falha no processamento" color="error" variant="outlined" />}
                                                {payment.cieloData.status == "NotFinished" && payment.appType == "CreditCard" && <Chip label={payment.cieloData?.creditCard?.reasonMessage} color="error" variant="outlined" />}
                                                {payment.cieloData.status == "PaymentConfirmed" && <Chip label="Pago" color="success" variant="outlined" />}
                                                {payment.cieloData.status == "Voided" && <Chip label="Cancelado" color="info" variant="outlined" />}
                                                {payment.cieloData.status == "Refunded" && <Chip label="Estornado" color="info" variant="outlined" />}
                                                {payment.cieloData.status == "Aborted" && <Chip label="Cancelado por falha" color="warning" variant="outlined" />}
                                                {payment.cieloData.status == "Scheduled" && <Chip label="Recorrência agendada" color="info" variant="outlined" />}
                                            </MDTypography>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <MDInput type="text" label="Shopify Payment Id" fullWidth value={payment.shopifyPaymentId || ""} disabled />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <MDInput type="text" label="Cielo Payment Code" fullWidth value={payment.cieloData?.paymentCode || ""} disabled />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <MDInput type="text" label="Forma de pagamento" fullWidth value={payment.appType || ""} disabled />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <MDInput type="text" label="Parcelas" fullWidth value={payment.installments || "1"} disabled />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <MDInput type="text" label="Valor" fullWidth value={payment.originalAmount?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) || ""} disabled />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <MDInput type="text" label="Valor com desconto ou juros" fullWidth value={payment.amount?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) || ""} disabled />
                                        </Grid>                                      
                                        <Grid item xs={12} md={6}>
                                            <MDInput type="text" label="Data" fullWidth value={new Date(payment.createdAt).toLocaleString() || ""} disabled />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <MDInput type="text" label="Status interno" fullWidth value={payment.status || ""} disabled />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <MDInput type="text" label="Status de pagamento" fullWidth value={payment.cieloData.status || ""} disabled />
                                        </Grid>
                                        {payment.walletType != null && <Grid item xs={12} md={6}>
                                            <MDInput type="text" label="WalletType" fullWidth value={payment.walletType || ""} disabled />
                                        </Grid>}
                                        <Grid item xs={12} md={12}>
                                            <MDTypography variant="h6">Dados do cliente</MDTypography>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <MDInput type="text" label="E-mail" fullWidth value={payment.customerEmail || ""} disabled />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <MDInput type="text" label="Telefone" fullWidth value={payment.customerPhoneNumber || ""} disabled />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <MDInput type="text" label="CPF/CNPJ" fullWidth value={payment.customerDocument || ""} disabled />
                                        </Grid>
                                        {payment.cieloData?.pixData?.qrCodeString !== null &&
                                            <>
                                                <Grid item xs={12} md={12} pb={1.2}>
                                                    <MDTypography variant="h6">Dados Pix</MDTypography>
                                                </Grid>

                                                <Grid item xs={12} md={12}>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12} md={6}>
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={12} md={12}>
                                                                    <MDInput type="text" label="Código Pix" fullWidth value={payment.cieloData?.pixData?.qrCodeString || ""} disabled />
                                                                </Grid>
                                                                <Grid item xs={12} md={12}>
                                                                    <MDInput type="text" label="Data expiração" fullWidth value={new Date(payment.cieloData?.pixData?.expirationDate).toLocaleString() || ""} disabled />
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <MDBox component="img" src={`data:image/png;base64, ${payment.cieloData?.pixData?.qrcodeBase64Image || ""}`} alt="Brand" width="12rem" fullwidth="true" />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        }

                                        {payment.cieloData?.boletoData?.barCodeNumber !== null &&
                                            <>
                                                <Grid item xs={12} md={12} pb={1.2}>
                                                    <MDTypography variant="h6">Dados Boleto</MDTypography>
                                                </Grid>

                                                <Grid item xs={12} md={12}>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12} md={12}>
                                                            <MDInput type="text" label="Url Boleto" fullWidth value={payment.cieloData?.boletoData?.url || ""} disabled />
                                                        </Grid>
                                                        <Grid item xs={12} md={12}>
                                                            <MDInput type="text" label="Linha digitável" fullWidth value={payment.cieloData?.boletoData?.digitableLine || ""} disabled />
                                                        </Grid>
                                                        <Grid item xs={12} md={12}>
                                                            <MDInput type="text" label="Data de vencimento" fullWidth value={new Date(payment.cieloData?.boletoData?.expirationDate).toLocaleString() || ""} disabled />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        }

                                        {payment.cieloData?.creditCard?.authorizationCode !== null &&
                                            <>
                                                <Grid item xs={12} md={12} pb={1.2}>
                                                    <MDTypography variant="h6">Dados Cartão de Crédito</MDTypography>
                                                </Grid>

                                                <Grid item xs={12} md={12}>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12} md={12}>
                                                            <MDInput type="text" label="Código de autorização" fullWidth value={payment.cieloData?.creditCard?.authorizationCode || ""} disabled />
                                                        </Grid>
                                                        <Grid item xs={12} md={12}>
                                                            <MDInput type="text" label="Código retorno cielo" fullWidth value={payment.cieloData?.creditCard?.reasonCode || ""} disabled />
                                                        </Grid>
                                                        <Grid item xs={12} md={12}>
                                                            <MDInput type="text" label="Mensagem retorno cielo" fullWidth value={payment.cieloData?.creditCard?.reasonMessage || ""} disabled />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        }

                                        {payment.cieloData?.creditCard?.fraudAnalysisStatus != null &&
                                            <>
                                                <Grid item xs={12} md={12} pb={1.2}>
                                                    <MDTypography variant="h6">Dados Análise de Risco</MDTypography>
                                                </Grid>

                                                <Grid item xs={12} md={12}>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12} md={4}>
                                                            <MDInput type="text" label="Id da transação no Antifraude" fullWidth value={payment.cieloData?.creditCard?.fraudAnalysisId || ""} disabled />
                                                        </Grid>
                                                        <Grid item xs={12} md={4}>
                                                            <MDInput type="text" label="Status da transação no Antifraude" fullWidth value={payment.cieloData?.creditCard?.fraudAnalysisStatus?.toString() || ""} disabled />
                                                        </Grid>
                                                        <Grid item xs={12} md={4}>
                                                            <MDInput type="text" label="Código de retorno do Antifraude" fullWidth value={payment.cieloData?.creditCard?.fraudAnalysisReasonCode || ""} disabled />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        }

                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TimelineList title="Histórico">
                                        {history}
                                    </TimelineList>
                                </Grid>
                            </Grid>}
                    </MDBox>
                </Card>
            </MDBox>
            <Footer />
        </DashboardLayout >
    );
}

export default Sale;